import Exports from "../../Pages/Mega/Exports";
import {
  ADD_EVENT_FAIL,
  ADD_EVENT_SUCCESS,
  GET_EVENTS_FAIL,
} from "../calendar/actionTypes";
import {
  ADD_SNAPCHAT_SUCCESS,
  DELETE_SNAPCHAT_SUCCESS,
  GET_SNAPCHAT_FAIL,
  GET_SNAPCHAT_SUCCESS,
  UPDATE_SNAPCHAT_SUCCESS,
} from "./actionTypes";

const INIT_STATE = {
  snapchat: [],
  defective: [],
  exports: [],
  error: {},
};

const SNAPCHAT = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_SNAPCHAT_SUCCESS:
      return {
        ...state,
        snapchat: action.payload.snapchat,
        defective: action.payload.defective,
      };

    case GET_SNAPCHAT_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case ADD_SNAPCHAT_SUCCESS:
      return {
        ...state,
        snapchat: [...state.snapchat, action.payload],
      };

    case ADD_EVENT_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case UPDATE_SNAPCHAT_SUCCESS:
      return {
        ...state,
        snapchat: state.snapchat.map((id) =>
          id.id === action.payload.id ? { id, ...action.payload } : id
        ),
        isEventUpdated: true,
      };

    // case UPDATE_EVENT_FAIL:
    //   return {
    //     ...state,
    //     error: action.payload,
    //     isEventUpdated: false,
    //   };

    case DELETE_SNAPCHAT_SUCCESS:
      return {
        ...state,
        snapchat: state.snapchat.filter((id) => id.id !== action.payload),
      };

    // case DELETE_EVENT_FAIL:
    //   return {
    //     ...state,
    //     error: action.payload,
    //   };

    default:
      return state;
  }
};

export default SNAPCHAT;
